export default "__VITE_ASSET__B$VSxq9G__"